import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
export const ClientDetailsFields = ({ idPrefix, values, errors, submitted, onChange }) => {
    const { t } = useTranslation();
    return (_jsxs(ClientFields, { children: [_jsx("legend", { children: t('checkout.clientDetailsTitle') }), _jsxs(Fields, { children: [_jsxs(Field, { "$wide": true, "$error": submitted && errors.fullName, children: [_jsx("label", { htmlFor: `${idPrefix}-full-name`, children: t('checkout.fullName') }), _jsx("input", { id: `${idPrefix}-full-name`, name: "fullName", type: "text", autoComplete: "name", maxLength: 120, value: values.fullName, onChange: (event) => onChange('fullName', event.target.value), "aria-invalid": submitted && errors.fullName, "aria-describedby": submitted && errors.fullName ? `${idPrefix}-full-name-error` : undefined, required: true }), submitted && errors.fullName && (_jsx(FieldError, { id: `${idPrefix}-full-name-error`, children: t('checkout.invalidName') }))] }), _jsxs(Field, { "$error": submitted && errors.email, children: [_jsx("label", { htmlFor: `${idPrefix}-email`, children: t('checkout.email') }), _jsx("input", { id: `${idPrefix}-email`, name: "email", type: "email", autoComplete: "email", maxLength: 254, value: values.email, onChange: (event) => onChange('email', event.target.value), "aria-invalid": submitted && errors.email, "aria-describedby": submitted && errors.email ? `${idPrefix}-email-error` : undefined, required: true }), submitted && errors.email && (_jsx(FieldError, { id: `${idPrefix}-email-error`, children: t('checkout.invalidEmail') }))] }), _jsxs(Field, { "$error": submitted && errors.phone, children: [_jsx("label", { htmlFor: `${idPrefix}-phone`, children: t('checkout.phone') }), _jsx("input", { id: `${idPrefix}-phone`, name: "phone", type: "tel", inputMode: "tel", autoComplete: "tel", maxLength: 40, value: values.phone, onChange: (event) => onChange('phone', event.target.value), "aria-invalid": submitted && errors.phone, "aria-describedby": submitted && errors.phone ? `${idPrefix}-phone-error` : undefined, required: true }), submitted && errors.phone && (_jsx(FieldError, { id: `${idPrefix}-phone-error`, children: t('checkout.invalidPhone') }))] })] }), _jsx(ContactNotice, { children: t('checkout.contactNotice') })] }));
};
const ClientFields = styled.fieldset `
  min-width: 0;
  margin: 1rem 0 1.5rem;
  border: 0;
  padding: 0;
  legend {
    margin-bottom: 0.85rem;
    padding: 0;
    color: ${({ theme }) => theme.colors.navy900};
    font-size: 1.125rem;
    font-weight: 700;
  }
`;
const Fields = styled.div `
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;
const Field = styled.div `
  min-width: 0;
  grid-column: ${({ $wide }) => ($wide ? '1 / -1' : 'auto')};
  label {
    display: block;
    margin-bottom: 0.4rem;
    color: ${({ theme }) => theme.colors.navy900};
    font-size: 0.875rem;
    font-weight: 700;
  }
  input {
    width: 100%;
    min-height: 3rem;
    border: 1px solid ${({ theme, $error }) => ($error ? theme.colors.danger : theme.colors.line)};
    border-radius: ${({ theme }) => theme.borderRadius.md};
    padding: 0.75rem 0.85rem;
    color: ${({ theme }) => theme.colors.ink};
    background: ${({ theme }) => theme.colors.white};
    font: inherit;
  }
  input:focus {
    border-color: ${({ theme }) => theme.colors.blue600};
  }
`;
const ContactNotice = styled.p `
  margin: 0.85rem 0 0;
  color: ${({ theme }) => theme.colors.muted};
  font-size: 0.8125rem;
  line-height: 1.55;
`;
const FieldError = styled.p `
  margin: 0.65rem 0 0;
  color: ${({ theme }) => theme.colors.danger};
  font-size: 0.875rem;
  line-height: 1.55;
`;
